import React from "react"
import { useSelector } from "react-redux"
import { Box } from "@mui/material"
import SideDrawerNav from "./SideDrawerNav"

const drawerWidth = 220
const miniWidth = 70

export default function LogisticaLayout({ children }) {
    const { drawerOpen } = useSelector(state => state.logistica)

    return (
        <Box sx={{ display: "flex" }}>
            <SideDrawerNav open={drawerOpen} />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    marginLeft: drawerOpen ? `${drawerWidth}px` : `${miniWidth}px`,
                    transition: "margin-left 0.2s",
                }}
            >
                {children}
            </Box>
        </Box>
    )
}
